export const CORE_PACKAGES_STATUS = {
	ENABLE: 'enable',
	DISABLE: 'disable',
	ENABLE_WAITING: 'waiting_for_enable',
	DISABLE_WAITING: 'waiting_for_disable',
};
